<script setup lang="ts">
import Footer from '@/layout/Footer.vue';
import Header from '@/layout/Header.vue';
</script>

<template>
  <Header />
  <main class="flex-auto bg-gray-50">
    <slot />
  </main>
  <Footer />
</template>
